import React from "react";

const InputLabel = ({ label }) => <label className="inputLabel">{label}</label>;

export default InputLabel;
